import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../utils/postData";

export const addComment = createAsyncThunk(
  "initiatives/addComment",
  async ({ initiativeId, data }, { rejectWithValue }) => {
    try {
      const response = await postData(
        `${process.env.REACT_APP_BASE_URL}api/initiatives/${initiativeId}/comments`,
        data
      );
      if (!response || !response.success) {
        return rejectWithValue(response?.message || "Failed to add comment");
      }
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to add comment");
    }
  }
);
